import { render, staticRenderFns } from "./PowerLadder.vue?vue&type=template&id=53abdd0e&scoped=true"
import script from "./PowerLadder.vue?vue&type=script&lang=js"
export * from "./PowerLadder.vue?vue&type=script&lang=js"
import style0 from "./PowerLadder.vue?vue&type=style&index=0&id=53abdd0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53abdd0e",
  null
  
)

export default component.exports